"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const store_1 = require("../store/store");
const bookingSlice_1 = require("../store/slices/bookingSlice");
const react_query_1 = require("@tanstack/react-query");
const useHandleBooking = () => {
    const dispatch = (0, store_1.useAppDispatch)();
    const queryClient = (0, react_query_1.useQueryClient)();
    const { isModalOpen, bookedAppointments, currentBooking } = (0, store_1.useAppSelector)((state) => state.booking);
    const selectedAppointment = bookedAppointments.find((appointment) => appointment.appointmentId === (currentBooking === null || currentBooking === void 0 ? void 0 : currentBooking.appointmentId)) || null;
    const [bookingFlowType, setBookingFlowType] = (0, react_1.useState)(null);
    const [preventReopen, setPreventReopen] = (0, react_1.useState)(false);
    const handleNewBooking = (0, react_1.useCallback)(() => {
        dispatch((0, bookingSlice_1.clearCurrentBooking)());
        dispatch((0, bookingSlice_1.openModal)());
    }, [dispatch]);
    const toggleBookingModal = (0, react_1.useCallback)(() => {
        setPreventReopen(true);
        if (isModalOpen) {
            dispatch((0, bookingSlice_1.closeModal)());
            queryClient.invalidateQueries({ queryKey: ['get-coming-appointments'] });
            queryClient.invalidateQueries({ queryKey: ['bookable-dates'] });
            dispatch((0, bookingSlice_1.clearCurrentBooking)());
            setBookingFlowType(null);
        }
        else {
            dispatch((0, bookingSlice_1.openModal)());
        }
    }, [isModalOpen, dispatch, queryClient]);
    const openBookingFlow = (0, react_1.useCallback)((flowType) => {
        if (bookingFlowType === flowType)
            return;
        setBookingFlowType(flowType);
        if (flowType === 'book') {
            handleNewBooking();
        }
        else {
            dispatch((0, bookingSlice_1.openModal)());
        }
    }, [dispatch, handleNewBooking, bookingFlowType]);
    (0, react_1.useEffect)(() => {
        if (!isModalOpen) {
            dispatch((0, bookingSlice_1.clearCurrentBooking)());
            setBookingFlowType(null);
        }
    }, [isModalOpen, dispatch]);
    return {
        isModalOpen,
        bookingFlowType,
        openBookingFlow,
        toggleBookingModal,
        setBookingFlowType,
        selectedAppointment,
        setPreventReopen,
        preventReopen,
    };
};
exports.default = useHandleBooking;
